import { render, staticRenderFns } from "./TelephoneBar.vue?vue&type=template&id=64865e60&"
import script from "./TelephoneBar.vue?vue&type=script&lang=js&"
export * from "./TelephoneBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports